<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="扣费流水"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学校名称">
          <el-select size="mini" v-model="params.SchoolId" clearable @change="query()">
            <el-option v-for="item in schoolList" :key="item.SchoolId" :value="item.SchoolId" :label="item.SchoolName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学号">
          <el-input v-model="params.StudentNumber" size="mini" placeholder="请填写学号"/>
        </el-form-item>
        <el-form-item label="卡号">
          <el-input v-model="params.CardNumber" size="mini" placeholder="请填写卡号"/>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="params.FullName" size="mini" placeholder="请填写姓名"/>
        </el-form-item>
        <el-form-item label="绑定电话">
          <el-input v-model="params.Mobile" type="number" size="mini" placeholder="请填写绑定电话"/>
        </el-form-item>
        <el-form-item label="扣费时间">
          <el-date-picker
            v-model="params.date"
            type="daterange"
            align="right"
            unlink-panels
            @change="setDate"
            range-separator="至"
            value-format="yyyy-MM-dd"
            size="mini"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width:300px;"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="SchoolName" label="学校名称" min-width="140"/>
        <el-table-column prop="StudentNumber" label="学号"/>
        <el-table-column prop="CardNumber" label="卡号" min-width="100"/>
        <el-table-column prop="FullName" label="姓名"/>
        <el-table-column prop="ContactNumber1" label="电话一" min-width="110"/>
        <el-table-column prop="Call2" label="电话二" min-width="110"/>
        <el-table-column prop="ContactNumber3" label="电话三" min-width="110"/>
        <el-table-column prop="ChargeAmount" label="扣费金额" min-width="100" />
        <el-table-column prop="TelAmount" label="话费已消费金额" min-width="120" />
        <el-table-column prop="Kind" label="类型"/>
        <el-table-column prop="CreateTime" label="扣费时间" min-width="140"/>
        <el-table-column prop="NotifyStatus" label="通知状态" width="90" align="center">
          <template slot-scope="{row}">
            <el-tag type="primary" v-if="row.NotifyStatus=='待通知'">待通知</el-tag>
            <el-tag type="success" v-else-if="row.NotifyStatus=='已通知'">已通知</el-tag>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import exportDialog from "./exportDialog5";

export default {
  mixins: [listMixin],
  components: { list,exportDialog },
  beforeMount() {
    this.schoolApi.list({ Status: 1 }).then(res => {
      if(res.Code == 0) {
        this.schoolList = res.Data;
        // if(res.Data.length>0) {
        //   this.params.SchoolId = res.Data[0].SchoolId;
        // }
      }
    })
  },
  data() {
    return {
      api: require("@/api/consume/rentflow").default,
      schoolApi: require("@/api/st/school").default,
      params: {
        SchoolId: null,
        StudentNumber: "",
        CardNumber: "",
        FullName: "",
        Mobile: "",
        StartTime: this.$commonJs.getToday(),
        EndTime: this.$commonJs.getToday(),
        date: [this.$commonJs.getToday(),this.$commonJs.getToday()]
      },
      schoolList: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近7天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近30天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近90天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    };
  },
  methods: {
    setDate(date) {
      if(date) {
        this.params.StartTime = date[0];
        this.params.EndTime = date[1];
      } else {
        this.params.StartTime = "";
        this.params.EndTime = "";
      }
      this.query();
    },
    export() {
      // this.$refs.exportDialog.open().then((that) => {
      //   that.getData(this.params);
      // });
      this.api.export(this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams));
    },
  },
};
</script>